import {
    getImportedAccountMappingResolution,
    ImportedAccountMappingResolution,
} from "@common/helpers/importedAccountMappingResolution";
import { ImportedAccount } from "@common/schemas/domains/accounting/importedAccount.schema";
import { Account } from "@common/types/domains/accounting/account";

export interface MappingSnapshotEntry {
    importedAccountId: string;
    kickAccountId: string;
}

interface SnapshotParams {
    importedAccounts: ImportedAccount[];
    kickAccountsById: Record<string, Account>;
}

export function snapshotEnabledMappings({
    importedAccounts,
    kickAccountsById,
}: SnapshotParams): MappingSnapshotEntry[] {
    return importedAccounts.flatMap((account) => {
        if (
            getImportedAccountMappingResolution({ account }) !==
                ImportedAccountMappingResolution.EXISTING_ACCOUNT ||
            account.pendingAccountId === null
        ) {
            return [];
        }
        const kickAccount = kickAccountsById[account.pendingAccountId];
        if (!kickAccount || kickAccount.isDisabled) {
            return [];
        }
        return [
            {
                importedAccountId: account.id,
                kickAccountId: account.pendingAccountId,
            },
        ];
    });
}

export interface MappingsBrokenByChartEdits {
    deletedImportedAccountIds: string[];
    archivedImportedAccountIds: string[];
}

export function findMappingsBrokenByChartEdits({
    mappedBefore,
    importedAccounts,
    kickAccountsById,
}: SnapshotParams & {
    mappedBefore: MappingSnapshotEntry[];
}): MappingsBrokenByChartEdits {
    const importedById = new Map(
        importedAccounts.map((account) => [account.id, account]),
    );
    const deletedImportedAccountIds: string[] = [];
    const archivedImportedAccountIds: string[] = [];
    for (const entry of mappedBefore) {
        const account = importedById.get(entry.importedAccountId);
        if (!account) {
            continue;
        }
        if (account.pendingAccountId === null) {
            deletedImportedAccountIds.push(account.id);
            continue;
        }
        if (
            account.pendingAccountId === entry.kickAccountId &&
            kickAccountsById[entry.kickAccountId]?.isDisabled
        ) {
            archivedImportedAccountIds.push(account.id);
        }
    }
    return { deletedImportedAccountIds, archivedImportedAccountIds };
}
